import { Target, ListTodo, Phone, BookOpen, CreditCard, FileText, CheckCircle2, Snowflake, Zap, CalendarClock } from 'lucide-react';

export const STATUS_CONFIG = {
  OPEN:      { label: 'Open',      color: 'var(--pd-focus)',   icon: Target },
  IN_FLIGHT: { label: 'In-flight', color: 'var(--pd-green)',   icon: Zap },
  ON_ICE:    { label: 'On-ice',    color: 'var(--pd-warning)', icon: Snowflake },
  DONE:      { label: 'Done',      color: 'var(--pd-subtle)',  icon: CheckCircle2 },
};

export const ITEM_TYPE_CONFIG = {
  task:    { label: 'Task',    icon: ListTodo,      color: 'var(--pd-focus)' },
  call:    { label: 'Call',    icon: Phone,         color: 'var(--pd-green)' },
  reading: { label: 'Reading', icon: BookOpen,      color: 'var(--pd-warning)' },
  payment: { label: 'Payment', icon: CreditCard,    color: 'var(--pd-crimson)' },
  note:    { label: 'Note',    icon: FileText,      color: 'var(--pd-muted)' },
  event:   { label: 'Meeting', icon: CalendarClock, color: 'var(--pd-blue)' },
};

export const STATUS_OPTIONS = ['OPEN', 'IN_FLIGHT', 'ON_ICE', 'DONE'];
